export function optimizePsous(turpe) {
  let margin = turpe?.margin || 1;
  if (turpe.dataquality > 50) {
    if (turpe.segment.toLowerCase() == "c5") {
      let psous = 36;
      if (turpe.pmax < 18) {
        psous = (turpe.pmax * margin).toFixed(0) - ((turpe.pmax * margin).toFixed(0) % 3);
        if ((turpe.pmax * margin).toFixed(0) % 3 > 0) psous = psous + 3;
      } else {
        psous = turpe.pmax * margin - ((turpe.pmax * margin).toFixed(0) % 6);
        if ((turpe.pmax * margin).toFixed(0) % 6 > 0) psous = psous + 6;
      }

      if (psous < (turpe.psmax * margin).toFixed(0)) {
        turpe.recps = psous;
      } else {
        turpe.recps = (turpe.psmax * margin).toFixed(0);
      }
    } else {
      if (
        turpe.segment.toLowerCase() == "c3" ||
        turpe.segment.toLowerCase() == "c2"
      ) {
        let psous = (turpe.pmaxpte * margin).toFixed(0) - ((turpe.pmaxpte * margin).toFixed(0) % 6);
        if ((turpe.pmaxpte * margin).toFixed(0) % 6 > 0) psous = psous + 6;
          turpe.recpspte = psous;
      }
      {
        let psous = (turpe.pmaxhph * margin).toFixed(0) - ((turpe.pmaxhph * margin).toFixed(0) % 6);
        if ((turpe.pmaxhph * margin).toFixed(0) % 6 > 0) psous = psous + 6;
        turpe.recpshph = psous;
      }
      {
        let psous = (turpe.pmaxhch * margin).toFixed(0) - ((turpe.pmaxhch * margin).toFixed(0) % 6);
        if ((turpe.pmaxhch * margin).toFixed(0) % 6 > 0) psous = psous + 6;
        turpe.recpshch = psous;
      }
      {
        let psous = (turpe.pmaxhpe * margin).toFixed(0) - ((turpe.pmaxhpe * margin).toFixed(0) % 6);
        if ((turpe.pmaxhpe * margin).toFixed(0) % 6 > 0) psous = psous + 6;
        turpe.recpshpe = psous;
      }
      {
        let psous = (turpe.pmaxhce * margin).toFixed(0) - ((turpe.pmaxhce * margin).toFixed(0) % 6);
        if ((turpe.pmaxhce * margin).toFixed(0) % 6 > 0) psous = psous + 6;
        turpe.recpshce = psous;
      }
      if (
        turpe.segment.toLowerCase() == "c3" ||
        turpe.segment.toLowerCase() == "c2"
      ) {
        if (turpe.recpshph < turpe.recpspte) turpe.recpshph = turpe.recpspte;
      }
      if (turpe.recpshch < turpe.recpshph) turpe.recpshch = turpe.recpshph;
      if (turpe.recpshpe < turpe.recpshch) turpe.recpshpe = turpe.recpshch;
      if (turpe.recpshce < turpe.recpshpe) turpe.recpshce = turpe.recpshpe;
      turpe.recps = turpe.recpshce;
    }
  } else {
    setNoRecommendation(turpe);
  }
}

export function calculateTurpeEco(turpe, ftaoptimization, force) {
  turpe.recfta = turpe.fta;
  turpe.cost = 0.0;
 // console.log(turpe);
  let initialcost = calculateTurpeCost(turpe, false);
  let newcost = calculateTurpeCost(turpe, true);
  //console.log(turpe.fta, turpe.recfta, ftaoptimization);
  if (ftaoptimization && turpe.segment.toLowerCase() != "c5") {
    if (contains(turpe.fta, "CU"))
      turpe.recfta = turpe.fta.replace("CU", "LU");
    else if (contains(turpe.fta, "LU"))
      turpe.recfta = turpe.fta.replace("LU", "CU");
    let newcostotherfta = calculateTurpeCost(turpe, true);
    //console.log(newcost, newcostotherfta);
    if (force || (newcostotherfta < newcost))
      newcost = newcostotherfta;
    else
      turpe.recfta = turpe.fta;
  }
  //console.log(initialcost, newcost);
  if (turpe.dataquality < 50 && !force)
    setNotPossible(turpe);
  else if (initialcost === 0 || newcost === 0)
    setNotPossible(turpe);
  else {
    if (turpe.segment.toLowerCase() == "c5") {
      if (turpe.recps != turpe.psmax)
        turpe.cost = 31.82;
    }
    else {
      if (
        turpe.recpspte != turpe.pspte ||
        turpe.recpshph != turpe.pshph ||
        turpe.recpshch != turpe.pshch ||
        turpe.recpshpe != turpe.pshpe ||
        turpe.recpshce != turpe.pshce
      )
        turpe.cost = 66.53;
    }
    if (turpe.fta != turpe.recfta) {
      turpe.cost = turpe.cost + 17.68;
    }

    if (!force && (initialcost + turpe.dcost - (turpe.cost + newcost) <= 0)) {
      setNoRecommendation(turpe);
    } else {
      turpe.ecosous = initialcost - newcost;
      turpe.ecodep = turpe.dcost;
      turpe.econet = initialcost + turpe.dcost - (turpe.cost + newcost);
    }
  }
}

function calculateTurpeCost(turpe, simulation) {
  let cost = 0.0;
  if (turpe.segment.toLowerCase() == "c4") {
    if (!simulation)
      cost = calculateTurpeCostC4(
        turpe.fta,
        turpe.pshph,
        turpe.pshch,
        turpe.pshpe,
        turpe.pshce,
        turpe.eahph,
        turpe.eahch,
        turpe.eahpe,
        turpe.eahce
      );
    else
      cost = calculateTurpeCostC4(
        turpe.recfta,
        turpe.recpshph,
        turpe.recpshch,
        turpe.recpshpe,
        turpe.recpshce,
        turpe.eahph,
        turpe.eahch,
        turpe.eahpe,
        turpe.eahce
      );
  } else if (
    turpe.segment.toLowerCase() == "c3" ||
    turpe.segment.toLowerCase() == "c2"
  ) {
    if (!simulation)
      cost = calculateTurpeCostC3C2(
        turpe.fta,
        turpe.pspte,
        turpe.pshph,
        turpe.pshch,
        turpe.pshpe,
        turpe.pshce,
        turpe.eapte,
        turpe.eahph,
        turpe.eahch,
        turpe.eahpe,
        turpe.eahce
      );
    else
      cost = calculateTurpeCostC3C2(
        turpe.recfta,
        turpe.recpspte,
        turpe.recpshph,
        turpe.recpshch,
        turpe.recpshpe,
        turpe.recpshce,
        turpe.eapte,
        turpe.eahph,
        turpe.eahch,
        turpe.eahpe,
        turpe.eahce
      );
  } else if (turpe.segment.toLowerCase() == "c5") {
    if (!simulation) cost = calculateTurpeCostC5(turpe.fta, turpe.psmax);
    else cost = calculateTurpeCostC5(turpe.fta, turpe.recps);
  }
  return cost;
}

function calculateTurpeCostC4(
  fta,
  pshph,
  pshch,
  pshpe,
  pshce,
  eahph,
  eahch,
  eahpe,
  eahce
) {
  if (!pshph || !pshch || !pshpe || !pshce)
    return 0;

  let cost = 0.0;
  let cphph = 0.0;
  let cphch = 0.0;
  let cphpe = 0.0;
  let cphce = 0.0;
  let cehph = 0.0;
  let cehch = 0.0;
  let cehpe = 0.0;
  let cehce = 0.0;

  if (contains(fta, "CU")) {
    cphph = 11.61;
    cphch = 7.11;
    cphpe = 5.9;
    cphce = 3.74;
    cehph = 5.15;
    cehch = 3.36;
    cehpe = 2.28;
    cehce = 1.8;
  } else if (contains(fta, "LU")) {
    cphph = 20.57;
    cphch = 12.51;
    cphpe = 10.48;
    cphce = 5.95;
    cehph = 4.43;
    cehch = 3.11;
    cehpe = 2.0;
    cehce = 1.7;
  }
  let powercost =
    pshph * cphph +
    (pshch - pshph) * cphch +
    (pshpe - pshch) * cphpe +
    (pshce - pshpe) * cphce;
  let energycost =
    eahph * cehph + eahch * cehch + eahpe * cehpe + eahce * cehce;
  energycost = energycost / 100; //c€->€
  cost = powercost + energycost;
  return cost;
}

function calculateTurpeCostC3C2(
  fta,
  pspte,
  pshph,
  pshch,
  pshpe,
  pshce,
  eapte,
  eahph,
  eahch,
  eahpe,
  eahce
) {
  if (!pshph || !pshch || !pshpe || !pshce || !pspte)
    return 0;

  let cost = 0.0;
  let cppte = 0.0;
  let cphph = 0.0;
  let cphch = 0.0;
  let cphpe = 0.0;
  let cphce = 0.0;
  let cepte = 0.0;
  let cehph = 0.0;
  let cehch = 0.0;
  let cehpe = 0.0;
  let cehce = 0.0;
  if (contains(fta, "CU")) {
    cppte = 4.88;
    cphph = 4.67;
    cphch = 4.4;
    cphpe = 4.26;
    cphce = 3.6;
    cepte = 3.73;
    cehph = 3.2;
    cehch = 2.17;
    cehpe = 1.64;
    cehce = 1.01;
  } else if (contains(fta, "LU")) {
    cppte = 19.36;
    cphph = 18.26;
    cphch = 13.85;
    cphpe = 9.71;
    cphce = 4.15;
    cepte = 2.8;
    cehph = 2.11;
    cehch = 1.38;
    cehpe = 0.89;
    cehce = 0.77;
  }
  let powercost =
    pspte * cppte +
    (pshph - pspte) * cphph +
    (pshch - pshph) * cphch +
    (pshpe - pshch) * cphpe +
    (pshce - pshpe) * cphce;
  let energycost =
    eapte * cepte +
    eahph * cehph +
    eahch * cehch +
    eahpe * cehpe +
    eahce * cehce;
  energycost = energycost / 100; //c€->€
  cost = powercost + energycost;
  return cost;
}

function calculateTurpeCostC5(fta, ps) {
  let cost = 0.0;
  let cp = 0.0;
  if (!ps)
    return 0;

  if (contains(fta, "CU")) {
    cp = 8.52;
  } else if (contains(fta, "MU")) {
    cp = 10.32;
  } else if (contains(fta, "LU")) {
    cp = 76.44;
  }
  cost = ps * cp;
  return cost;
}

function contains(fta, b) {
  let regex = new RegExp(`${b}`);
  return regex.test(fta);
}

function setNoRecommendation(turpe) {
  turpe.ecosous = 0;
  turpe.ecodep = 0;
  turpe.cost = 0;
  turpe.econet = 0;
  turpe.recpspte = turpe.pspte;
  turpe.recpshph = turpe.pshph;
  turpe.recpshch = turpe.pshch;
  turpe.recpshpe = turpe.pshpe;
  turpe.recpshce = turpe.pshce;
  turpe.recps = turpe.psmax;
  turpe.recfta = turpe.fta;
}

function setNotPossible(turpe) {
  turpe.ecosous = 0;
  turpe.ecodep = 0;
  turpe.cost = 0;
  turpe.econet = 0;
  turpe.recpspte = null;
  turpe.recpshph = null;
  turpe.recpshch = null;
  turpe.recpshpe = null;
  turpe.recpshce = null;
  turpe.recps = null;
  turpe.recfta = "-";
}